import AccountCircleOutlinedIcon from "@mui/icons-material/AccountCircleOutlined";
import { Card, CardMedia, Checkbox, Grid, Typography } from "@mui/material";
import html2pdf from "html2pdf.js";
import moment from "moment";
import { useEffect, useMemo, useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import SignatureCanvas from "react-signature-canvas";
import CustomButton from "../../../components/CustomButton";
import CustomModal from "../../../components/CustomModal/CustomModal";
import CustomTextField from "../../../components/CustomTextField";
import CustomSelect from "../../../components/Select/Select";
import {
  addBillingItemsByPaymentId,
  assignFormByAppointmentIdWoLoader,
  getClinicFormsWoLoader,
  updateClinicUserCollectionRefund,
  updatePetFromByIdWoLoader,
} from "../../../redux/reducers/clinicSlice";
import {
  admitPatientByPatientId,
  admitPet,
  getPetsCompliantSummaryWoLoader,
} from "../../../redux/reducers/petSlice";
import { getClinicVets } from "../../../redux/reducers/vetSlice";
import { AppColors } from "../../../util/AppColors";
import { billingTabEnum } from "../../../util/enum";
import PaymentModeDropdown from "../../CommonComponents/PaymentModeDropdown";

const cardSty = {
  borderRadius: 1,
  padding: 2,
  borderTopColor: AppColors.appPrimary,
};

const initialStatusList = [
  { name: "Stable", value: "Stable" },
  { name: "Monitoring", value: "Monitoring" },
  { name: "Critical", value: "Critical" },
  { name: "Isolation", value: "Isolation" },
];

const initValues = {
  kennelNumber: [],
  remark: "",
  vet: null,
  facilityType: "Kennel",
  initialStatus: "Stable",
  admissionFee: "",
  collectDeposit: false,
  depositAmount: "",
  paymentMode: null,
  nonRefundable: false,
  consentGiven: false,
};
const facilitesList = [
  { name: "Kennel", value: "Kennel" },
  { name: "Operation Theatre", value: "OperationTheatre" },
];

const InpatientAdmitPatient = ({
  modalVisible,
  onCloseMod,
  modalData,
  sendToRecovery = false,
}) => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const sigCanvas = useRef(null);
  const pdfRef = useRef(null);
  const [modalVsble, setModalVsble] = useState(false);
  const [admitValues, setAdmitValues] = useState(initValues);
  const [admitErrors, setAdmitErrors] = useState({});
  const [consentStep, setConsentStep] = useState(false);
  const [consentCheck1, setConsentCheck1] = useState(false);
  const [consentCheck2, setConsentCheck2] = useState(false);
  const [consentErr, setConsentErr] = useState(false);
  const [isSigned, setIsSigned] = useState(false);
  const [signatureDataUrl, setSignatureDataUrl] = useState(null);
  const [clinicLogoImg, setClinicLogoImg] = useState(null);
  const [vetSignUrl, setVetSignUrl] = useState(null);
  const [pendingData, setPendingData] = useState(null);
  const clinicVets = useSelector((state) => state?.vet?.vets?.vets);
  const clinicForms = useSelector((state) => state?.clinic?.forms);
  const petAndApntData = useSelector(
    (state) => state?.pet?.petAndAppointmentDetails,
  );
  // const { facilities } = useSelector((state) => state?.clinic);
  const reqData = modalData?.appoinment ? modalData?.appoinment : modalData;
  const mandateDataRaw = sessionStorage.getItem("mandateData");
  const { facilities, clinicDet } = useMemo(() => {
    if (!mandateDataRaw) return { facilities: [], clinicDet: {} };
    try {
      const reqData = JSON.parse(mandateDataRaw);
      return {
        facilities: Array.isArray(reqData?.facilities)
          ? reqData?.facilities
          : [],
        clinicDet: reqData?.clinic ?? {},
      };
    } catch {
      return { facilities: [], clinicDet: {} };
    }
  }, [mandateDataRaw]);

  useEffect(() => {
    dispatch(getClinicVets());
    dispatch(getClinicFormsWoLoader());
    // dispatch(getClinicFacilities());
  }, []);

  useEffect(() => {
    if (!clinicDet?.image) return;
    fetch(clinicDet.image)
      .then((res) => res.blob())
      .then((blob) => {
        const reader = new FileReader();
        reader.readAsDataURL(blob);
        reader.onloadend = () => setClinicLogoImg(reader.result);
      })
      .catch(() => {});
  }, [clinicDet?.image]);

  useEffect(() => {
    const sig = reqData?.signature ?? reqData?.appoinment?.signature;
    if (!sig) return;
    fetch(sig, { method: "GET", headers: {} })
      .then((res) => res.blob())
      .then((blob) => setVetSignUrl(URL.createObjectURL(blob)))
      .catch(() => {});
  }, [reqData?.signature, reqData?.appoinment?.signature]);

  useEffect(() => {
    setModalVsble(modalVisible);
  }, [modalVisible]);

  const onCloseAdmitModal = () => {
    setModalVsble(false);
    setAdmitValues(initValues);
    setAdmitErrors({});
    setConsentStep(false);
    setConsentCheck1(false);
    setConsentCheck2(false);
    setConsentErr(false);
    setIsSigned(false);
    setSignatureDataUrl(null);
    setPendingData(null);
    onCloseMod();
  };

  const getConsentForm = () =>
    clinicForms?.find((f) => f?.serviceType?.toLowerCase() === "admission") ??
    null;

  const buildConsentContent = (form) => {
    if (!form?.content) return "";
    return form.content
      .replace(/\{\{PetName\}\}/gi, reqData?.petName ?? "")
      .replace(/\{\{ClinicName\}\}/gi, clinicDet?.name ?? "");
  };

  const handleAdmitChange = (name, value) => {
    const reqValue = Array.isArray(value)
      ? value
      : typeof value === "object"
        ? value?.value?.toString()
        : value;
    setAdmitValues({ ...admitValues, [name]: value });
    setAdmitErrors({
      ...admitErrors,
      [name]: reqValue?.length > 0 ? "" : "This field is required",
    });
  };

  const getNonNegativeNumberError = (value) => {
    if (value === "" || value === null || value === undefined) {
      return "This field is required";
    }
    const num = Number(value);
    if (Number.isNaN(num)) return "Enter a valid number";
    if (num < 0) return "Value must be 0 or greater";
    return "";
  };

  const getPositiveNumberError = (value) => {
    if (value === "" || value === null || value === undefined) {
      return "This field is required";
    }
    const num = Number(value);
    if (Number.isNaN(num)) return "Enter a valid number";
    if (num <= 0) return "Value must be greater than 0";
    return "";
  };

  const getVetList = () => {
    const reqVetList = clinicVets
      ?.filter((vl) => vl?.userType?.some((ut) => ut?.name === "ROLE_DOCTOR"))
      ?.map((vet) => {
        return { name: vet?.name, value: vet?.doctorId, id: vet?.doctorId };
      });
    return reqVetList ?? [];
  };

  const getKennelList = (typ) => {
    return facilities
      ?.filter(
        (li) => li?.type?.toLowerCase() === typ?.toLowerCase() && li?.status,
      )
      ?.map((li) => {
        return { name: li?.name, value: li?.name, id: li?.id };
      });
  };

  const dispatchAdmit = (data) => {
    dispatch(
      reqData?.patientId
        ? admitPatientByPatientId({ patientId: reqData?.patientId, data })
        : admitPet({
            petId: reqData?.petId,
            vetId: admitValues?.vet?.value,
            data,
            url: `?appointmentStatus=recovery${modalData?.appointmentStatus === "inprogress" ? "&tab=checkin" : ""}`,
          }),
    ).then(async (res) => {
      if (!res?.payload) return;

      const appointmentStatus = (
        reqData?.appointmentStatus ??
        modalData?.appointmentStatus ??
        ""
      ).toLowerCase();
      const paymentId =
        reqData?.paymentId ?? modalData?.paymentId ?? petAndApntData?.paymentId;
      const admissionFee = Number(data?.price ?? data?.total ?? 0);

      if (appointmentStatus === "consultation" && paymentId) {
        await dispatch(
          addBillingItemsByPaymentId({
            paymentId,
            data: {
              billType: billingTabEnum?.Treatment,
              adminCharge: "N",
              adminChargeAmount: 0,
              name: data?.serviceName ?? "Admission",
              quantity: 1,
              type: "service",
              discount: 0,
              percentage: false,
              subUnit: "Unit",
              patientWorkbook: false,
              tabName: billingTabEnum?.Treatment,
              autoConsumed: false,
              amtPaid: 0,
              price: admissionFee,
              mrpPrice: admissionFee,
              tax: 0,
              total: admissionFee,
            },
          }),
        );
      }

      const shouldCollectDeposit =
        !reqData?.patientId &&
        !!data?.collectDeposit &&
        Number(data?.depositAmount) > 0 &&
        !!reqData?.userId;

      if (!shouldCollectDeposit) {
        onCloseMod("Api Success");
        onCloseAdmitModal();
        navigate("/dashboard", {
          state: { selectedTab: "Inpatient" },
        });
        return;
      }

      const form = new FormData();
      if (reqData?.userName) form.append("userName", reqData.userName);
      const userMobile = reqData?.userMobile ?? reqData?.mobile;
      if (userMobile) form.append("userMobile", userMobile);
      form.append("paymentType", "Collect");
      form.append(
        "paymentMode",
        data?.paymentMode?.value ?? data?.paymentMode ?? "Cash",
      );
      form.append("advanceAmount", Number(`+${Number(data.depositAmount)}`));
      if (reqData?.petId) form.append("petId", reqData.petId);
      if (reqData?.petName) form.append("petName", reqData.petName);
      if (data?.nonRefundable) form.append("type", "nonrefund");
      form.append(
        "reason",
        data?.nonRefundable
          ? "Inpatient - Non-refundable Deposit"
          : "Inpatient Refundable Deposit",
      );

      dispatch(
        updateClinicUserCollectionRefund({
          userId: reqData.userId,
          form,
          successMsg: "Payment updated successfully!",
        }),
      ).finally(() => {
        onCloseMod("Api Success");
        onCloseAdmitModal();
        navigate("/dashboard", {
          state: { selectedTab: "Inpatient" },
        });
      });
    });
  };

  const handleAdmitPatient = () => {
    const admissionFeeError = !sendToRecovery
      ? getNonNegativeNumberError(admitValues?.admissionFee)
      : "";
    const depositAmountError =
      !sendToRecovery && admitValues?.collectDeposit
        ? getPositiveNumberError(admitValues?.depositAmount)
        : "";
    const paymentModeError =
      !sendToRecovery &&
      admitValues?.collectDeposit &&
      !admitValues?.paymentMode
        ? "This field is required"
        : "";
    if (
      admitValues?.kennelNumber?.length === 0 ||
      (!sendToRecovery && !admitValues?.vet) ||
      (!sendToRecovery && admitValues?.remark?.length === 0) ||
      !admitValues?.consentGiven ||
      !!admissionFeeError ||
      !!depositAmountError ||
      !!paymentModeError
    ) {
      return setAdmitErrors({
        ...admitErrors,
        kennelNumber:
          admitValues?.kennelNumber?.length === 0
            ? "This field is required"
            : "",
        vet: !admitValues?.vet ? "This field is required" : "",
        remark:
          admitValues?.remark?.length === 0 ? "This field is required" : "",
        consentGiven: !admitValues?.consentGiven
          ? "This field is required"
          : "",
        admissionFee: admissionFeeError,
        depositAmount: depositAmountError,
        paymentMode: paymentModeError,
      });
    }
    const admissionFee = Number(admitValues?.admissionFee ?? 0);
    const depositAmount = admitValues?.collectDeposit
      ? Number(admitValues?.depositAmount ?? 0)
      : 0;
    const data = {
      appointmentId: reqData?.appointmentId,
      kennelNumber: admitValues?.kennelNumber?.map((li) => li?.value),
      remark: admitValues?.remark ?? "",
      hospitalization: sendToRecovery ? false : true,
      doctorId: admitValues?.vet?.value ?? reqData?.doctorId,
      serviceId: null,
      serviceName: "Admission",
      variantId: null,
      price: admissionFee,
      tax: 0,
      total: admissionFee,
      collectDeposit: !!admitValues?.collectDeposit,
      depositAmount,
      // paymentMode: admitValues?.paymentMode?.value ?? null,
      nonRefundable: !!admitValues?.nonRefundable,
      consentGiven: !!admitValues?.consentGiven,
      inpatientStatus: admitValues?.initialStatus,
    };
    if (sendToRecovery) {
      data.facilityType = admitValues?.facilityType ?? "Kennel";
    }
    const consentForm = getConsentForm();
    if (consentForm && !sendToRecovery) {
      setPendingData(data);
      setConsentStep(true);
      return;
    }

    dispatchAdmit(data);
  };

  const handleConsentConfirm = async () => {
    if (!consentCheck1 || !consentCheck2) return setConsentErr(true);
    if (!sigCanvas.current || sigCanvas.current.isEmpty())
      return setConsentErr(true);

    // Ensure latest signature data URL is in state before PDF render
    const latestSigUrl = sigCanvas.current.toDataURL();
    setSignatureDataUrl(latestSigUrl);

    const apntId = reqData?.appointmentId;
    const formId = consentForm?.formId;

    // Wait one tick so React re-renders the hidden pdfRef div with the signature image
    await new Promise((resolve) => setTimeout(resolve, 80));

    if (apntId && formId) {
      try {
        // 1. Assign the form to the appointment
        const assignRes = await dispatch(
          assignFormByAppointmentIdWoLoader({ apntId, formId }),
        );
        if (assignRes?.payload) {
          // 2. Fetch the updated complaint summary to get the petFormId
          const summaryRes = await dispatch(
            getPetsCompliantSummaryWoLoader(apntId),
          );
          const petForms = summaryRes?.payload?.data?.forms ?? [];
          const petFormId = petForms
            ?.filter((f) => f?.formId === formId)
            ?.slice(-1)?.[0]?.petFormId;

          if (petFormId && pdfRef.current) {
            // 3. Generate PDF and upload using .then() chain (html2pdf requirement)
            await new Promise((resolve) => {
              html2pdf()
                .from(pdfRef.current)
                .outputPdf("blob")
                .then((blob) => {
                  const ts = Date.now();
                  const formData = new FormData();
                  formData.append("file", blob, `consent_${ts}.pdf`);
                  dispatch(
                    updatePetFromByIdWoLoader({
                      formId: petFormId,
                      form: formData,
                    }),
                  )
                    .then(resolve)
                    .catch(resolve);
                });
            });
          }
        }
      } catch (_) {}
    }

    dispatchAdmit(pendingData);
  };

  const consentForm = getConsentForm();

  return (
    <>
      {/* ── CONSENT STEP MODAL ── */}
      <CustomModal
        open={consentStep}
        onClose={() => {
          setConsentStep(false);
          setConsentCheck1(false);
          setConsentCheck2(false);
          setConsentErr(false);
          setIsSigned(false);
          setSignatureDataUrl(null);
          setPendingData(null);
        }}
        header="Consent Form"
        modal
        modalWidth={55}
        headerBold
      >
        <div className="scroll-70vh ph20">
          {/* Form content rendered from HTML */}
          {consentForm?.content ? (
            <div
              className="mb20"
              style={{
                border: "1px solid #e0e0e0",
                borderRadius: 6,
                padding: "16px",
                background: "#fafafa",
                fontSize: 13,
                lineHeight: 1.7,
              }}
              dangerouslySetInnerHTML={{
                __html: buildConsentContent(consentForm),
              }}
            />
          ) : null}

          {/* Checkbox 1 */}
          <div
            className="flex-row-ali-cen"
            style={{ gap: 8, marginBottom: 10 }}
          >
            <Checkbox
              checked={consentCheck1}
              onChange={(e) => {
                const checked = e.target.checked;
                setConsentCheck1(checked);
                if (!checked) {
                  sigCanvas.current?.clear();
                  setIsSigned(false);
                  setSignatureDataUrl(null);
                  return;
                }
                if (consentCheck2) setConsentErr(false);
              }}
              required
              sx={{
                color:
                  consentErr && !consentCheck1
                    ? AppColors.red
                    : AppColors.appPrimary,
                "&.Mui-checked": { color: AppColors.appPrimary },
                p: 0.5,
              }}
            />
            <Typography
              sx={{
                fontSize: 13,
                color: consentErr && !consentCheck1 ? AppColors.red : "#212121",
              }}
            >
              I confirm I am the pet parent or authorized agent for{" "}
              <strong>{reqData?.petName}</strong> and give my informed consent
              for <strong>{clinicDet?.name}</strong> to proceed as described.{" "}
              <span style={{ color: AppColors.red }}>*</span>
            </Typography>
          </div>

          {/* Checkbox 2 */}
          <div className="flex-row-ali-cen" style={{ gap: 8, marginBottom: 8 }}>
            <Checkbox
              checked={consentCheck2}
              onChange={(e) => {
                const checked = e.target.checked;
                setConsentCheck2(checked);
                if (!checked) {
                  sigCanvas.current?.clear();
                  setIsSigned(false);
                  setSignatureDataUrl(null);
                  return;
                }
                if (consentCheck1) setConsentErr(false);
              }}
              required
              sx={{
                color:
                  consentErr && !consentCheck2
                    ? AppColors.red
                    : AppColors.appPrimary,
                "&.Mui-checked": { color: AppColors.appPrimary },
                p: 0.5,
              }}
            />
            <Typography
              sx={{
                fontSize: 13,
                color: consentErr && !consentCheck2 ? AppColors.red : "#212121",
              }}
            >
              I understand and accept financial responsibility for the cost of
              this treatment. <span style={{ color: AppColors.red }}>*</span>
            </Typography>
          </div>

          {consentErr && (!consentCheck1 || !consentCheck2) ? (
            <Typography sx={{ fontSize: 11, color: AppColors.red, mb: 1.5 }}>
              Both consent checkboxes are required to continue.
            </Typography>
          ) : (
            <div style={{ marginBottom: 12 }} />
          )}

          {/* Signature — enabled only when both required checkboxes are ticked */}
          <>
            <Typography
              sx={{
                fontSize: 11,
                fontWeight: 700,
                color: "#616161",
                letterSpacing: "0.5px",
                textTransform: "uppercase",
                mb: 0.8,
                opacity: consentCheck1 && consentCheck2 ? 1 : 0.5,
              }}
            >
              Signature of Pet Parent / Authorized Agent *
            </Typography>
            <div
              style={{
                border: `1px solid ${
                  consentErr && consentCheck1 && consentCheck2
                    ? AppColors.red
                    : "#bdbdbd"
                }`,
                borderRadius: 6,
                overflow: "hidden",
                background: "#fff",
                width: "100%",
                pointerEvents: consentCheck1 && consentCheck2 ? "auto" : "none",
                opacity: consentCheck1 && consentCheck2 ? 1 : 0.5,
              }}
            >
              <SignatureCanvas
                ref={sigCanvas}
                penColor="#1a237e"
                canvasProps={{
                  width: 560,
                  height: 160,
                  style: { display: "block" },
                }}
                onEnd={() => {
                  if (!consentCheck1 || !consentCheck2) return;
                  setIsSigned(true);
                  setSignatureDataUrl(sigCanvas.current?.toDataURL() ?? null);
                  setConsentErr(false);
                }}
              />
            </div>
            {consentErr && consentCheck1 && consentCheck2 ? (
              <Typography sx={{ fontSize: 11, color: AppColors.red, mt: 0.5 }}>
                Signature is required to proceed.
              </Typography>
            ) : null}
            <div className="flex-row-ali-cen mt10 flex-end">
              <div>
                <CustomButton
                  text="Clear Signature"
                  smallBtn
                  disabled={!consentCheck1 || !consentCheck2}
                  grayBtn={!consentCheck1 || !consentCheck2}
                  onClick={() => {
                    if (!consentCheck1 || !consentCheck2) {
                      setConsentErr(true);
                      return;
                    }
                    sigCanvas.current?.clear();
                    setIsSigned(false);
                    setSignatureDataUrl(null);
                  }}
                />
              </div>
              <div className="ml10">
                <CustomButton
                  text="Confirm & Admit"
                  onClick={handleConsentConfirm}
                  smallBtn
                  disabled={!consentCheck1 || !consentCheck2 || !isSigned}
                  grayBtn={!consentCheck1 || !consentCheck2 || !isSigned}
                />
              </div>
            </div>
          </>
        </div>
      </CustomModal>

      {/* ── HIDDEN PDF RENDER DIV for consent form ── */}
      <div style={{ display: "none" }}>
        <div ref={pdfRef} className="bg ph20 mb20">
          <div className="flex-row-ali-cen mv20">
            <div className="w20Per">
              <div className="pl20">
                {clinicLogoImg ? (
                  <img src={clinicLogoImg} className="img-h75" alt="" />
                ) : (
                  <div className="flex-center h50img">
                    <Typography className="font-bold fs30 white-color capitalize">
                      {clinicDet?.name?.[0]}
                    </Typography>
                  </div>
                )}
              </div>
            </div>
            <div className="w60Per flex-center">
              <div className="font-bold fs30 blue-color">
                {consentForm?.name ?? "Consent Form"}
              </div>
            </div>
            <div className="w20Per flex1-end">
              <div className="pr10">
                <img
                  src={require("../../../assets/images/png/VetInstantLogo.png")}
                  onError={(e) => {
                    e.target.style.display = "none";
                  }}
                  alt=""
                  className="wh50 blu-back p5"
                />
              </div>
            </div>
          </div>
          <div className="yellow-bar" />
          <div
            dangerouslySetInnerHTML={{
              __html: buildConsentContent(consentForm),
            }}
          />
          <div className="mt100">
            <div className="flex-row-ali-cen">
              {signatureDataUrl ? (
                <img src={signatureDataUrl} alt="" className="h60" />
              ) : null}
              <div className="flex1-end">
                {vetSignUrl ? (
                  <img src={vetSignUrl} alt="" className="h60" />
                ) : null}
              </div>
            </div>
            <div className="flex-row-ali-cen">
              <Typography className="fs16 font-bold black">
                Signature of pet parent
              </Typography>
              <div className="flex1-end">
                <Typography className="fs16 font-bold black">
                  Signature of licensed veterinarian
                </Typography>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* ── ADMISSION FORM MODAL ── */}
      <CustomModal
        open={modalVsble}
        onClose={onCloseAdmitModal}
        header="Admit Patient"
        rightModal
        modalWidth={30}
        headerBold
      >
        <div className="scroll-85vh">
          <Grid container spacing={1} className="ph20">
            <Grid item xs={12}>
              <Card sx={cardSty} className="CustomCard-back-appointment">
                <div className="flex-row">
                  <Grid item xs={3}>
                    <div className="flex-center">
                      {reqData?.petImage ? (
                        <CardMedia
                          image={reqData?.petImage}
                          className="CustomCard-img3-bill"
                        />
                      ) : (
                        <div className="flex-center h50img">
                          <Typography className="font-bold fs30 white-color capitalize">
                            {reqData?.petName?.[0]}
                          </Typography>
                        </div>
                      )}
                    </div>
                  </Grid>
                  <div className="flex-row">
                    <div className="flex-start">
                      <div className="flex-column">
                        <div className="flex-row">
                          <div className="mb10 txt-semi-bold black fs14 capitalize">
                            {reqData?.petName}
                          </div>
                          <Typography
                            className={`ml5 text capitalize ${
                              reqData?.gender === "male"
                                ? "card-blue-color"
                                : "card-rose-color"
                            }`}
                          >
                            {`(${reqData?.gender})`}
                          </Typography>
                        </div>
                        <Typography className="mb10 txt-regular card-gray-color fs12">
                          {reqData?.breed}
                        </Typography>
                      </div>
                    </div>
                  </div>
                </div>
                <div>
                  <div className="flex-row parentcontainer mt10">
                    <div className="flex-row iconcontainer">
                      <AccountCircleOutlinedIcon
                        sx={{ width: 25, height: 25 }}
                      />
                      <div className="txt-semi-bold fs14 capitalize">
                        {reqData?.userName}
                      </div>
                    </div>
                    <div className="meeting-doctor">
                      {moment(reqData?.dob).fromNow()} ({reqData?.dob})
                    </div>
                  </div>
                </div>
              </Card>
            </Grid>
            {/* ── ADMISSION DETAILS ── */}
            <Grid item xs={12}>
              <Typography
                sx={{
                  fontSize: 11,
                  fontWeight: 700,
                  color: AppColors.appPrimary,
                  letterSpacing: "0.6px",
                  textTransform: "uppercase",
                  mt: 1.5,
                  mb: 0.5,
                }}
              >
                Admission Details
              </Typography>
              <div
                style={{ borderTop: `1px solid #e0e0e0`, marginBottom: 12 }}
              />
            </Grid>

            {/* Facility Type (sendToRecovery only) */}
            {sendToRecovery ? (
              <Grid item xs={12}>
                <div className="mb20">
                  <CustomSelect
                    list={facilitesList}
                    handleChange={(e) =>
                      handleAdmitChange("facilityType", e?.target?.value)
                    }
                    name="facilityType"
                    label="Facility Type *"
                    select
                    value={admitValues?.facilityType}
                    error={!!admitErrors?.facilityType}
                    helperText={admitErrors?.facilityType}
                  />
                </div>
              </Grid>
            ) : null}

            {/* Assign Kennel | Initial Status | Attending Vet */}
            <Grid item xs={12} sm={12}>
              <Typography
                sx={{
                  fontSize: 11,
                  fontWeight: 700,
                  color: "#616161",
                  letterSpacing: "0.5px",
                  textTransform: "uppercase",
                  mb: 0.8,
                }}
              >
                Assign Kennel
              </Typography>
              <CustomSelect
                list={getKennelList(admitValues?.facilityType)}
                handleChange={(e) =>
                  handleAdmitChange("kennelNumber", e?.target?.value)
                }
                name="kennelNumber"
                multiSelectSearchCheck
                value={admitValues?.kennelNumber ?? []}
                error={!!admitErrors?.kennelNumber}
                helperText={admitErrors?.kennelNumber}
              />
            </Grid>

            <Grid item xs={12} sm={12}>
              <Typography
                sx={{
                  fontSize: 11,
                  fontWeight: 700,
                  color: "#616161",
                  letterSpacing: "0.5px",
                  textTransform: "uppercase",
                  mb: 0.8,
                }}
              >
                Initial Status
              </Typography>
              <CustomSelect
                list={initialStatusList}
                handleChange={(e) =>
                  handleAdmitChange("initialStatus", e?.target?.value)
                }
                name="initialStatus"
                select
                value={admitValues?.initialStatus}
              />
            </Grid>

            {/* Attending Vet (= old "Vet Name" single select) */}
            {!sendToRecovery ? (
              <Grid item xs={12} sm={12}>
                <Typography
                  sx={{
                    fontSize: 11,
                    fontWeight: 700,
                    color: "#616161",
                    letterSpacing: "0.5px",
                    textTransform: "uppercase",
                    mb: 0.8,
                  }}
                >
                  Attending Vet
                </Typography>
                <CustomSelect
                  list={getVetList()}
                  handleChange={(e, value) => handleAdmitChange("vet", value)}
                  name="vet"
                  search
                  value={admitValues?.vet}
                  error={!!admitErrors?.vet}
                  helperText={admitErrors?.vet}
                  placeholder="e.g. Jhon"
                />
              </Grid>
            ) : null}

            {/* Reason for Admission (= old "Reason" / remark field) */}
            {!sendToRecovery ? (
              <Grid item xs={12}>
                <Typography
                  sx={{
                    fontSize: 11,
                    fontWeight: 700,
                    color: "#616161",
                    letterSpacing: "0.5px",
                    textTransform: "uppercase",
                    mb: 0.8,
                  }}
                >
                  Reason for Admission / Provisional Diagnosis
                </Typography>
                <CustomTextField
                  fullWidth
                  multiline
                  rows={3}
                  handleChange={(e) =>
                    handleAdmitChange("remark", e?.target?.value)
                  }
                  required={true}
                  value={admitValues?.remark ?? ""}
                  error={!!admitErrors?.remark}
                  helperText={admitErrors?.remark}
                  placeholder="e.g. Post-op monitoring after entrotomy"
                />
              </Grid>
            ) : null}

            {/* Admission fees */}
            {!sendToRecovery ? (
              <Grid item xs={12}>
                <Typography
                  sx={{
                    fontSize: 11,
                    fontWeight: 700,
                    color: "#616161",
                    letterSpacing: "0.5px",
                    textTransform: "uppercase",
                    mb: 0.8,
                    mt: 0.5,
                  }}
                >
                  Admission exam / processing fee (₹)
                </Typography>
                <CustomTextField
                  fullWidth
                  type="number"
                  value={admitValues?.admissionFee ?? ""}
                  handleChange={(e) => {
                    const value = e?.target?.value;
                    setAdmitValues((prev) => ({
                      ...prev,
                      admissionFee: value,
                    }));
                    setAdmitErrors((prev) => ({
                      ...prev,
                      admissionFee: getNonNegativeNumberError(value),
                    }));
                  }}
                  error={!!admitErrors?.admissionFee}
                  helperText={admitErrors?.admissionFee}
                />
              </Grid>
            ) : null}

            {!sendToRecovery ? (
              <Grid item xs={12}>
                <div className="flex-row-ali-cen" style={{ gap: 6 }}>
                  <Checkbox
                    checked={!!admitValues?.collectDeposit}
                    onChange={(e) => {
                      const checked = e.target.checked;
                      setAdmitValues((prev) => ({
                        ...prev,
                        collectDeposit: checked,
                        depositAmount: checked ? prev.depositAmount : "",
                        paymentMode: checked ? prev.paymentMode : null,
                        nonRefundable: checked ? prev.nonRefundable : false,
                      }));
                      setAdmitErrors((prev) => ({
                        ...prev,
                        depositAmount: "",
                        paymentMode: "",
                      }));
                    }}
                    sx={{
                      color: AppColors.appPrimary,
                      "&.Mui-checked": { color: AppColors.appPrimary },
                      p: 0.5,
                    }}
                  />
                  <Typography
                    sx={{ fontSize: 13, fontWeight: 500, color: "#212121" }}
                  >
                    Collect Deposit
                  </Typography>
                </div>
              </Grid>
            ) : null}

            {!sendToRecovery && admitValues?.collectDeposit ? (
              <Grid item xs={12}>
                <Typography
                  sx={{
                    fontSize: 11,
                    fontWeight: 700,
                    color: "#616161",
                    letterSpacing: "0.5px",
                    textTransform: "uppercase",
                    mb: 0.8,
                  }}
                >
                  How much deposit amount is collected?
                </Typography>
                <CustomTextField
                  fullWidth
                  type="number"
                  value={admitValues?.depositAmount ?? ""}
                  handleChange={(e) => {
                    const value = e?.target?.value;
                    setAdmitValues((prev) => ({
                      ...prev,
                      depositAmount: value,
                    }));
                    setAdmitErrors((prev) => ({
                      ...prev,
                      depositAmount: getPositiveNumberError(value),
                    }));
                  }}
                  label="Deposit Amount"
                  error={!!admitErrors?.depositAmount}
                  helperText={admitErrors?.depositAmount}
                />
              </Grid>
            ) : null}

            {!sendToRecovery && admitValues?.collectDeposit ? (
              <Grid item xs={12}>
                <Typography
                  sx={{
                    fontSize: 11,
                    fontWeight: 700,
                    color: "#616161",
                    letterSpacing: "0.5px",
                    textTransform: "uppercase",
                    mb: 0.8,
                  }}
                >
                  Payment Method
                </Typography>
                <PaymentModeDropdown
                  value={admitValues?.paymentMode}
                  onChange={(value) => {
                    setAdmitValues((prev) => ({
                      ...prev,
                      paymentMode: value,
                    }));
                    setAdmitErrors((prev) => ({
                      ...prev,
                      paymentMode: value ? "" : "This field is required",
                    }));
                  }}
                  hideAdvancedAdjustment
                  error={!!admitErrors?.paymentMode}
                  helperText={admitErrors?.paymentMode}
                />
              </Grid>
            ) : null}

            {!sendToRecovery && admitValues?.collectDeposit ? (
              <Grid item xs={12}>
                <div className="flex-row-ali-cen" style={{ gap: 6 }}>
                  <Checkbox
                    checked={!!admitValues?.nonRefundable}
                    onChange={(e) =>
                      setAdmitValues((prev) => ({
                        ...prev,
                        nonRefundable: e.target.checked,
                      }))
                    }
                    sx={{
                      color: AppColors.appPrimary,
                      "&.Mui-checked": { color: AppColors.appPrimary },
                      p: 0.5,
                    }}
                  />
                  <Typography
                    sx={{ fontSize: 13, fontWeight: 500, color: "#212121" }}
                  >
                    Non-refundable
                  </Typography>
                </div>
              </Grid>
            ) : null}

            {/* Consent checkbox */}
            <Grid item xs={12}>
              <div className="flex-row-ali-cen" style={{ gap: 6 }}>
                <Checkbox
                  checked={!!admitValues?.consentGiven}
                  onChange={(e) => {
                    const checked = e.target.checked;
                    setAdmitValues((prev) => ({
                      ...prev,
                      consentGiven: checked,
                    }));
                    setAdmitErrors((prev) => ({
                      ...prev,
                      consentGiven: checked ? "" : "This field is required",
                    }));
                  }}
                  sx={{
                    color: admitErrors?.consentGiven
                      ? AppColors.red
                      : AppColors.appPrimary,
                    "&.Mui-checked": { color: AppColors.appPrimary },
                    p: 0.5,
                  }}
                />
                <Typography
                  sx={{ fontSize: 13, fontWeight: 500, color: "#212121" }}
                >
                  Owner informed of estimated cost and has consented to
                  hospitalization *
                </Typography>
              </div>
              {admitErrors?.consentGiven ? (
                <Typography className="red-color fs12 mt5">
                  {admitErrors.consentGiven}
                </Typography>
              ) : null}
            </Grid>
          </Grid>
          <div className="flex1-end mt20">
            <Grid item xs={12} sm={12} md={3} lg={3} xl={3}>
              <CustomButton
                text="Submit"
                onClick={handleAdmitPatient}
                smallBtn
                disabled={!admitValues?.consentGiven}
                grayBtn={!admitValues?.consentGiven}
              />
            </Grid>
          </div>
        </div>
      </CustomModal>
    </>
  );
};

export default InpatientAdmitPatient;
